import { Button, Stack, Typography } from '@mui/material';
import React from 'react';

import PortfolioMissingIcon from '../../assests/images/PortfolioMasterDataMissingIcon.svg';

const CustomAlert = ({ showButton = false, btnText = '', titleMsg, detailMessage, onCheckItems, color='#B05788', textColor = "#fff" }) => {
  return (
    <Stack
      sx={{
        width: '100%',
        backgroundColor: 'white', //'#FFF2D2',
        padding: '16px',
        borderRadius: '9px',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: color 
      }}>
      <Stack direction="row" gap="16px" alignItems="center">
        <img src={PortfolioMissingIcon} alt={'missing-value-portfolio-summary-icon'} />
        <Stack direction="column" gap={1}>
          <Typography variant="h5" style={{ color: textColor }}>{titleMsg}</Typography>
          <Typography sx={{ fontWeight: 'bold', overflowY: 'auto', maxHeight: '4rem', maxWidth: '60rem', color: textColor }} variant="body2">
            {detailMessage}
          </Typography>
        </Stack>
      </Stack>
      {showButton && (
        <Button
          variant="contained"
          color="primary"
          onClick={onCheckItems}
          sx={{
            width: '10vw',
            height: '40px'
          }}>
          {btnText}
        </Button>
      )}
    </Stack>
  );
};

export default CustomAlert;